import { createSlice } from '@reduxjs/toolkit';
import { isEmpty } from 'lodash';
const initialState = {
    selectedSubtitleLang: '',
    subtitleFontSize: 14,
    interimText: undefined,
    finalText: undefined,
    lastFinalTexts: [],
};
const speechServicesSlice = createSlice({
    name: 'speech-services',
    initialState,
    reducers: {
        updateSelectedSubtitleLang: (state, action) => {
            state.selectedSubtitleLang = action.payload;
            state.interimText = undefined;
            state.finalText = undefined;
        },
        updateSubtitleFontSize: (state, action) => {
            state.subtitleFontSize = action.payload;
        },
        addSpeechSubtitleText: (state, action) => {
            if (action.payload.type === 'interim') {
                state.interimText = action.payload.result;
            }
            else {
                state.interimText = undefined;
                state.finalText = action.payload.result;
                if (!isEmpty(action.payload.result.text)) {
                    state.lastFinalTexts.push(action.payload.result);
                }
            }
        },
    },
});
export const { updateSelectedSubtitleLang, updateSubtitleFontSize, addSpeechSubtitleText, } = speechServicesSlice.actions;
export default speechServicesSlice.reducer;
